import { Dialog, DialogSurface } from "@fluentui/react-components"
import { CheckmarkCircleRegular, DismissCircleRegular, InfoRegular, WarningRegular } from "@fluentui/react-icons"
import { useAppContext } from "@/app/AppContext"
import { renderDialog } from "@/components/Dialog"
import { NotificationType } from "@/models/models"

const getNotificationIcon = (type: NotificationType) => {
    const style = { fontSize: '24px', marginRight: '8px' }
    switch (type) {
        case 'success':
            return <CheckmarkCircleRegular style={{ ...style, color: 'var(--notification-success)' }} />
        case 'error':
            return <DismissCircleRegular style={{ ...style, color: 'var(--notification-error)' }} />
        case 'warning':
            return <WarningRegular style={{ ...style, color: 'var(--notification-warning)' }} />
        case 'info':
        default:
            return <InfoRegular style={{ ...style, color: 'var(--notification-info)' }} />
    }
}

const NotificationDialog: React.FC = () => {
    const { notifications, dismissNotification } = useAppContext()

    // Find the oldest active (non-dismissed) notification
    const activeNotification = [...notifications].reverse().find(n => !n.dismissed)

    if (!activeNotification) return null

    const handleDismiss = () => {
        dismissNotification(activeNotification.id)
    }

    return (
        <Dialog modalType="alert" open={true} onOpenChange={(_event, data) => { if (!data.open) handleDismiss() }}>
            <DialogSurface>
                {renderDialog(
                    activeNotification.title,
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        {getNotificationIcon(activeNotification.type)}
                        <span>{activeNotification.message}</span>
                    </div>,
                    [{ label: 'OK', onClick: handleDismiss, appearance: 'primary' }]
                )}
            </DialogSurface>
        </Dialog>
    )
}

export default NotificationDialog
